import * as constants from './constants'

const INITIAL_STATE = {
  loading: false,
  activities: {
    meta: {
      code: 200,
      message: '',
      errors: []
    },
    data: {
      data: [],
      pagination: {
        page: 1,
        limit: 10,
        total_page: 1,
        total_data: 1
      }
    }
  },
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_LOADING:
      return Object.assign({}, state, {
        loading: action.data
      })
    case constants.SET_ACTIVITIES:
      return Object.assign({}, state, {
        activities: action.data
      })
    default: return state
  }
}
